'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmailCapturePromptMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isEmailCapturePromptMessage = exports.isEmailCapturePromptMessage = (0, _isType.isType)(_messageTypes.EMAIL_CAPTURE_PROMPT);